var rpc = {
	gear: {
		calculateInitUploadGas: {
			description: "Calculate gas for Init message using upload_program extrinsic",
			params: [
				{
					name: "source",
					type: "H256"
				},
				{
					name: "code",
					type: "Vec<u8>"
				},
				{
					name: "payload",
					type: "Vec<u8>"
				},
				{
					name: "value",
					type: "u128"
				},
				{
					name: "allow_other_panics",
					type: "bool"
				}
			],
			type: "GasInfo"
		},
		calculateInitCreateGas: {
			description: "Calculate gas for Init message using create_program extrinsic",
			params: [
				{
					name: "source",
					type: "H256"
				},
				{
					name: "code_id",
					type: "H256"
				},
				{
					name: "payload",
					type: "Vec<u8>"
				},
				{
					name: "value",
					type: "u128"
				},
				{
					name: "allow_other_panics",
					type: "bool"
				}
			],
			type: "GasInfo"
		},
		calculateHandleGas: {
			description: "Calculate gas for Handle message",
			params: [
				{
					name: "source",
					type: "H256"
				},
				{
					name: "dest",
					type: "H256"
				},
				{
					name: "payload",
					type: "Vec<u8>"
				},
				{
					name: "value",
					type: "u128"
				},
				{
					name: "allow_other_panics",
					type: "bool"
				}
			],
			type: "GasInfo"
		},
		calculateReplyGas: {
			description: "Calculate gas for Reply message",
			params: [
				{
					name: "source",
					type: "H256"
				},
				{
					name: "message_id",
					type: "H256"
				},
				{
					name: "payload",
					type: "Vec<u8>"
				},
				{
					name: "value",
					type: "u128"
				},
				{
					name: "allow_other_panics",
					type: "bool"
				}
			],
			type: "GasInfo"
		},
		readMetahash: {
			params: [
				{
					name: "program_id",
					type: "H256"
				},
				{
					name: "at",
					type: "Option<BlockHash>"
				}
			],
			type: "H256"
		},
		readState: {
			params: [
				{
					name: "program_id",
					type: "H256"
				},
				{
					name: "payload",
					type: "Vec<u8>"
				},
				{
					name: "at",
					type: "Option<BlockHash>"
				}
			],
			type: "Bytes"
		},
		readStateUsingWasm: {
			params: [
				{
					name: "program_id",
					type: "H256"
				},
				{
					name: "payload",
					type: "Bytes"
				},
				{
					name: "fn_name",
					type: "Bytes"
				},
				{
					name: "wasm",
					type: "Bytes"
				},
				{
					name: "argument",
					type: "Option<Bytes>"
				},
				{
					name: "at",
					type: "Option<BlockHash>"
				}
			],
			type: "Bytes"
		}
	},
	chainSpec_unstable: {
		chainName: {
			params: [
			],
			type: "String"
		},
		properties: {
			params: [
			],
			type: "String"
		},
		genesisHash: {
			params: [
			],
			type: "H256"
		}
	},
	transaction_unstable: {
		submitAndWatch: {
			params: [
			]
		},
		unwatch: {
			params: [
			]
		}
	},
	runtime: {
		wasmBlobVersion: {
			description: "Returns the version of the WASM blob in storage.",
			params: [
			],
			type: "String"
		}
	}
};
var rpc$1 = {
	rpc: rpc
};

export { rpc$1 as default, rpc };
